import _defineProperty from "/app/vetiver/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { createBreakpoints } from '../utils/createBreakpoints';
var breakpoints = createBreakpoints({}); // ----------------------------------------------------------------------

export var remToPx = function remToPx(value) {
  return Math.round(parseFloat(value) * 16);
};
export var pxToRem = function pxToRem(value) {
  return "".concat(value / 16, "rem");
};
export var responsiveFontSizes = function responsiveFontSizes(_ref) {
  var _ref2;

  var sm = _ref.sm,
      md = _ref.md,
      lg = _ref.lg;
  return _ref2 = {}, _defineProperty(_ref2, breakpoints.up('sm'), {
    fontSize: pxToRem(sm)
  }), _defineProperty(_ref2, breakpoints.up('md'), {
    fontSize: pxToRem(md)
  }), _defineProperty(_ref2, breakpoints.up('lg'), {
    fontSize: pxToRem(lg)
  }), _ref2;
};